import { render, staticRenderFns } from "./ResourceEdit.vue?vue&type=template&id=13d8e4f6&"
import script from "./ResourceEdit.vue?vue&type=script&lang=js&"
export * from "./ResourceEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEdit.vue?vue&type=style&index=0&id=13d8e4f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports